export default function () {
  return [
    { time: '07:00:00' }, { time: '07:15:00' }, { time: '07:30:00' }, { time: '07:45:00' },
    { time: '08:00:00' }, { time: '08:15:00' }, { time: '08:30:00' }, { time: '08:45:00' },
    { time: '09:00:00' }, { time: '09:15:00' }, { time: '09:30:00' }, { time: '09:45:00' },
    { time: '10:00:00' }, { time: '10:15:00' }, { time: '10:30:00' }, { time: '10:45:00' },
    { time: '11:00:00' }, { time: '11:15:00' }, { time: '11:30:00' }, { time: '11:45:00' },
    { time: '12:00:00' }, { time: '12:15:00' }, { time: '12:30:00' }, { time: '12:45:00' },
    { time: '13:00:00' }, { time: '13:15:00' }, { time: '13:30:00' }, { time: '13:45:00' },
    { time: '14:00:00' }, { time: '14:15:00' }, { time: '14:30:00' }, { time: '14:45:00' },
    { time: '15:00:00' }, { time: '15:15:00' }, { time: '15:30:00' }, { time: '15:45:00' },
    { time: '16:00:00' }, { time: '16:15:00' }, { time: '16:30:00' }, { time: '16:45:00' },
    { time: '17:00:00' }, { time: '17:15:00' }, { time: '17:30:00' }, { time: '17:45:00' },
    { time: '18:00:00' }, { time: '18:15:00' }, { time: '18:30:00' }, { time: '18:45:00' },
    { time: '19:00:00' }, { time: '19:15:00' }, { time: '19:30:00' }, { time: '19:45:00' },
    { time: '20:00:00' }, { time: '20:15:00' }, { time: '20:30:00' }, { time: '20:45:00' },
    { time: '21:00:00' }
  ];
}
